<template>
  <div style="padding-bottom: 8px;">
    <v-row class="ma-0" style="align-items: center; gap: 8px;">
      <v-col class="px-0 py-0">
        <search-filter-input
            v-if="showSearch"
            variant="outlined"
            :placeholder="placeholder"
            @input-updated="onSearchTextUpdated">
        </search-filter-input>
      </v-col>

      <v-col v-if="showToggle" cols="auto" class="pa-0">
        <div class="view-toggle">
          <v-btn
              icon
              variant="text"
              flat
              :ripple="false"
              class="toggle-btn"
              :class="{ active: isCardView }"
              @click="cardView(true)"
          >
            <v-icon icon="fas fa-border-all" size="16" />
          </v-btn>

          <v-btn
              icon
              variant="text"
              flat
              :ripple="false"
              class="toggle-btn"
              :class="{ active: !isCardView }"
              @click="cardView(false)"
          >
            <v-icon icon="fas fa-bars" size="16" />
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import SearchFilterInput from './SearchFilterInput.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    SearchFilterInput
  },
  props: {
    placeholder: {
      type: String
    },
    showSearch: {
      type: Boolean,
    },
    isCardView: {
      type: Boolean,
    },
    showToggle: {
      type: Boolean,
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    onSearchTextUpdated(text: string): void {
      this.$emit('search', text);
    },
    cardView(value: boolean): void {
      this.$emit('cardView', value);
    },
  }
})
</script>

<style scoped>
.view-toggle {
  display: flex;
  align-items: center;
  padding: 3px;
  border: 1px solid #e6eef0;
  background: #fff;
  height: 37px;
  border-radius: 6px;
  box-sizing: border-box;
  overflow: hidden;
}

.toggle-btn {
  color: #b8e6e4;
  background: transparent !important;
  transition: background 0.15s ease, color 0.15s ease;
  height: 28px !important;
  width: 28px !important;
  min-height: 28px !important;
  min-width: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.toggle-btn:hover {
  background: #eef8f8 !important;
  color: #1c7c7a;
}

.toggle-btn.active {
  background: #dff4f3 !important;
  color: #1c7c7a;
}
</style>